import { useFeatureFlags } from "@lyteflo/components";
import { usePermissions } from "@lyteflo/utils";

// `usePermissions` cannot read the flag context itself: the provider lives
// in a package that depends on it.
export const usePortalPermissions = () => {
  const { flags } = useFeatureFlags();
  return usePermissions(flags);
};
